import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatAccordion } from "@angular/material/expansion";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenPageContentComponent } from "../../../../shared/modules/loren-page-content/loren-page-content.component";
import { MatButton } from "@angular/material/button";
import { FaqSection } from "../loren-faq-section/faq-section";
import { FaqBase } from "./faq.base";

@Component({
  templateUrl: "./faq.html",
  styleUrls: ["./faq.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoPipe,
    MatAccordion,
    LorenPageContentComponent,
    MatButton,
    FaqSection
  ]
})
export class Faq extends FaqBase {
}
